
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faSquare as fasSquare,
    } from '@fortawesome/pro-solid-svg-icons/faSquare';

    export default {
        name: 'JobViewPayTable',

        components: {
            FontAwesomeIcon,
        },

        props: {
            label: {
                type: String,
                default: '',
            },

            figure: {
                type: [Number, String],
                default: '',
            },

            isDark: {
                type: Boolean,
                default: false,
            },

            variant: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                icons: {
                    fasSquare,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'pay-table',
                    this.getVariantClass,
                    this.getDarkClass,
                ];
            },

            getVariantClass() {
                return this.variant ? `is-${this.variant}` : '';
            },

            getDarkClass() {
                return this.isDark ? 'is-dark' : '';
            },

            getFigure() {
                return this.figure.replace('pro rata', '');
            },
        },
    };
